import type * as React from 'react';

function SvgArrowTopRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="9" viewBox="0 0 10 9" width="10" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M8.75336 1.5217L3.41448 0.201025C3.16066 0.11407 2.89899 0.301608 2.8413 0.561945C2.78361 0.822281 2.95543 1.08918 3.20605 1.14165L7.50785 2.2027L0.592779 7.13517C0.3782 7.28823 0.331935 7.59137 0.489484 7.81224C0.647034 8.03312 0.94872 8.08807 1.1633 7.93501L8.07837 3.00254L7.68108 7.4154C7.63621 7.67863 7.86704 7.91053 8.13198 7.94074C8.39691 7.97094 8.63343 7.78661 8.63832 7.52457L9.12777 2.04659C9.14371 1.90419 9.09135 1.79935 9.0377 1.71486C8.96971 1.63496 8.85407 1.54602 8.75336 1.5217Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgArrowTopRight;
